import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import { DownloadGroupName } from '../../DownloadManager/reducer';
import RoutesUtils from '../../../utils/routes';
import { DriveItemListOrigin } from '../../DriveItemListPage/constants';
import { hashHistory } from 'react-router';
import Content from '../../../components/DownloadGroupToast/Content';
import DownloadManagerUtils from '../../../utils/downloadManager';

const mapStateToProps = (state: StoreState) => {
	const {
		downloadManager: {
			downloadGroups,
		},
		routerParamsHistory,
	} = state;
	const currentOrigin = RoutesUtils.getCurrentOrigin(routerParamsHistory);
	const isDownloadsFolder = currentOrigin === DriveItemListOrigin.Downloads;
	const startedDownloadGroup = DownloadManagerUtils.getStartedDownloadGroup(downloadGroups);
	const downloadingGroup = DownloadManagerUtils.getDownloadingGroup(downloadGroups);
	const isDownloading = downloadingGroup !== null;
	const linkToDownloadsPage = isDownloadsFolder
		? undefined
		: `#${RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Downloads, null)}${hashHistory.getCurrentLocation().search}`;
	const message = getMessage(downloadingGroup, startedDownloadGroup);

	return {
		isDownloading,
		message,
		linkToDownloadsPage,
	};
};


const getMessage = (downloadingGroup: DownloadGroupName | null, startedDownloadGroup: DownloadGroupName | null): string => {
	if (downloadingGroup === DownloadGroupName.ALL) {
		return 'messages.download_all_toast_in_progress';
	}

	if (downloadingGroup === DownloadGroupName.IMPORTANT) {
		return 'messages.download_importants_toast_in_progress';
	}

	if (downloadingGroup === DownloadGroupName.SELECTED) {
		return 'messages.download_selected_toast_in_progress';
	}

	if (startedDownloadGroup === DownloadGroupName.ALL) {
		return 'messages.download_all_toast_paused';
	}

	if (startedDownloadGroup === DownloadGroupName.IMPORTANT) {
		return 'messages.download_importants_toast_paused';
	}

	if (startedDownloadGroup === DownloadGroupName.SELECTED) {
		return 'messages.download_selected_toast_paused';
	}

	return '';
};

export default connect(mapStateToProps)(Content);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DownloadGroupToast/Content/index.tsx